import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import MediaPlayer from '@ts-core/modules/media/components/MediaPlayer';
import MediaItemsList from '@ts-core/components/MediaItemsList';
import BackButton from '@ts-core/components/BackButton';

const BaseMediaPlayerPage = (props) => {
  const {
    mediaItems,
    loadingMediaItems,
    allMediaItemsError,
    selectedMediaItem,
    loadingSelectedMediaItem,
    selectedMediaItemError,
    allowDownload,
    onSelectMediaItem,
    onGoBack,
    trackSession,
    onMediaPlay,
    onMediaTimeUpdate,
    onMediaSeeked,
    onMediaEnded,
  } = props;

  const intl = useIntl();

  return (
    <Box display="flex" flexDirection="column">
      <Box height={40} mt={{ xs: 2, md: 0 }} display="flex" alignItems="center" mb={2} ml={-2}>
        <BackButton onGoBack={onGoBack} title={selectedMediaItem?.name} subtitle="Videos" />
        {/* <Typography variant="h6">{}</Typography> */}
      </Box>
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }}>
        <Box flexGrow={1} width={{ xs: '100%', md: undefined }}>
          <MediaPlayer
            media={selectedMediaItem}
            loading={loadingSelectedMediaItem}
            error={selectedMediaItemError}
            trackSession={trackSession}
            onMediaPlay={onMediaPlay}
            onMediaTimeUpdate={onMediaTimeUpdate}
            onMediaSeeked={onMediaSeeked}
            onMediaEnded={onMediaEnded}
            allowDownload={allowDownload}
          />
        </Box>

        <Box
          width={{ xs: '100%', md: 600 }}
          ml={{ xs: 0, md: 2 }}
          mt={{ xs: 2, md: 0 }}
          pl={1}
          borderLeft={{ xs: undefined, md: '1px solid rgba(0, 0, 0, 0.12)' }}
        >
          <MediaItemsList
            title={intl.formatMessage({
              id: 'mediaItems.otherMediaItemsInSubject',
              defaultMessage: 'Otros videos en este tema',
            })}
            mediaItems={mediaItems}
            loading={loadingMediaItems}
            error={allMediaItemsError}
            onSelectMediaItem={onSelectMediaItem}
            selectedMediaItem={selectedMediaItem}
          />
        </Box>
      </Box>
    </Box>
  );
};

BaseMediaPlayerPage.propTypes = {
  mediaItems: PropTypes.array,
  loadingMediaItems: PropTypes.bool,
  allMediaItemsError: PropTypes.string,

  selectedMediaItem: PropTypes.object,
  loadingSelectedMediaItem: PropTypes.bool,
  selectedMediaItemError: PropTypes.string,
  trackSession: PropTypes.bool,
  allowDownload: PropTypes.bool,

  onSelectMediaItem: PropTypes.func,
  onGoBack: PropTypes.func,

  onMediaPlay: PropTypes.func,
  onMediaTimeUpdate: PropTypes.func,
  onMediaSeeked: PropTypes.func,
  onMediaEnded: PropTypes.func,
};

BaseMediaPlayerPage.defaultProps = {
  mediaItems: [],
  loadingMediaItems: false,
  allMediaItemsError: undefined,
  trackSession: undefined,
  allowDownload: undefined,

  selectedMediaItem: {},
  loadingSelectedMediaItem: false,
  selectedMediaItemError: undefined,

  onSelectMediaItem() {},
  onGoBack() {},

  onMediaPlay: undefined,
  onMediaTimeUpdate: undefined,
  onMediaSeeked: undefined,
  onMediaEnded: undefined,
};

export default BaseMediaPlayerPage;
